import React, { useState } from 'react'
import EsgReport from './EsgReport';
import SasbReport from './SasbReport';


const ExportReport = () => {
    return (
        <>
            <EsgReport />
            <SasbReport />
        </>
    )

}

export default ExportReport;